import React from 'react';
import { motion } from 'framer-motion';

const Logo = ({ size = 'default' }) => {
  const sizes = {
    small: { width: 120, height: 32, textSize: 'text-lg' },
    default: { width: 160, height: 40, textSize: 'text-xl' },
    large: { width: 200, height: 50, textSize: 'text-2xl' }
  };

  const { textSize } = sizes[size] || sizes.default;

  return (
    <motion.div 
      className="flex items-center gap-3 cursor-pointer"
      whileHover={{ scale: 1.02 }}
      transition={{ type: "spring", stiffness: 400, damping: 10 }}
      data-testid="nav-logo"
    >
      {/* Logo Icon - Geometric Tech Design */}
      <div className="relative">
        <svg 
          width="44" 
          height="44" 
          viewBox="0 0 44 44" 
          fill="none" 
          xmlns="http://www.w3.org/2000/svg"
          className="drop-shadow-[0_0_10px_rgba(0,240,255,0.5)]"
        >
          {/* Outer hexagon */}
          <motion.path
            d="M22 2L40 12V32L22 42L4 32V12L22 2Z"
            stroke="#00F0FF"
            strokeWidth="1.5"
            fill="none"
            initial={{ pathLength: 0 }}
            animate={{ pathLength: 1 }}
            transition={{ duration: 2, ease: "easeInOut" }}
          />
          
          {/* Inner geometric pattern */}
          <motion.path
            d="M22 8L34 15V29L22 36L10 29V15L22 8Z"
            stroke="#00F0FF"
            strokeWidth="1"
            fill="rgba(0, 240, 255, 0.1)"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.5, duration: 1 }}
          />
          
          {/* Center P symbol */}
          <motion.text
            x="22"
            y="26"
            textAnchor="middle"
            fill="#00F0FF"
            fontSize="16"
            fontWeight="bold"
            fontFamily="monospace"
            initial={{ opacity: 0, scale: 0.5 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ delay: 1, duration: 0.5 }}
          >
            P
          </motion.text>
          
          {/* Data flow lines */}
          <motion.circle
            cx="22"
            cy="22"
            r="2"
            fill="#00F0FF"
            initial={{ scale: 0 }}
            animate={{ scale: [0, 1.5, 1] }}
            transition={{ delay: 1.5, duration: 0.5 }}
          />
          
          {/* Corner nodes */}
          {[[22, 2], [40, 12], [40, 32], [22, 42], [4, 32], [4, 12]].map(([cx, cy], i) => (
            <motion.circle
              key={i}
              cx={cx}
              cy={cy}
              r="2"
              fill="#00F0FF"
              initial={{ opacity: 0 }}
              animate={{ opacity: [0, 1, 0.6] }}
              transition={{ delay: 0.2 * i, duration: 1, repeat: Infinity, repeatDelay: 2 }}
            />
          ))}
        </svg>
        
        {/* Glow effect */}
        <div className="absolute inset-0 blur-xl bg-[#00F0FF]/20 -z-10" />
      </div>

      {/* Text Logo */}
      <div className="flex flex-col">
        <motion.span 
          className={`${textSize} font-black tracking-wider bg-gradient-to-r from-white via-gray-200 to-gray-400 bg-clip-text text-transparent`}
          style={{ 
            fontFamily: "'IBM Plex Sans', sans-serif",
            textShadow: '0 0 30px rgba(0, 240, 255, 0.3)'
          }}
          initial={{ opacity: 0, x: -20 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8 }}
        >
          PAPES US
        </motion.span>
        <motion.span 
          className="text-[10px] tracking-[0.3em] text-[#00F0FF]/60 font-mono uppercase"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.5, duration: 0.5 }}
        >
          Enterprise
        </motion.span>
      </div>
    </motion.div>
  );
};

export default Logo;
